import React from 'react';

// -- MUI -- //
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

function ControlMesage(props) {
  const controlMessage = props.controlMessage;

  return (
    <Card
      sx={{
        minWidth: 150,
        maxWidth: 550,
        boxShadow: 'none',
        border: 'none',
        margin: '0 auto',
      }}
      className='card-message'
    >
      {/* <CardContent> */}
      <Typography
        variant='h2'
        sx={{ fontSize: 22, fontWeight: 600, textAlign: 'center' }}
        color='grey'
        gutterBottom
      >
        {controlMessage}
      </Typography>
      {/* </CardContent> */}
    </Card>
  );
}

export default ControlMesage;
